<template>
    <transition name="fade" mode="out-in">
        <router-view @loader="hideLoader"></router-view>
    </transition>
</template>

<script>
export default {
    name: "Wrapper",
    methods: {
        hideLoader() {
            this.$emit('loader');
        }
    }
}
</script>

<style scoped>

</style>
